var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge p-1 mr-1",class:_vm.clazz},[_vm._v(" "+_vm._s(_vm.stateStr)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }